import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { Pick } from '../../../core/competitions/competitions';

/** Presentational — no data fetching of its own. Read-only by default,
 *  rendering of a contestant's picks, grouped into regular/alternate.
 *  Shared by the entries modal (Slice 7, single competition) and the
 *  contestant modal (Slice 8, one of these per competition in that
 *  contestant's history) — both of those leave allowRemove() false, so
 *  they're unaffected by F-028's optional remove affordance below. */
@Component({
  selector: 'app-pick-list',
  imports: [],
  templateUrl: './pick-list.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pick-list.css',
})
export class PickList {
  readonly picks = input<Pick[]>([]);
  /** F-028 — site-admin "recreate historical entries" flow only; every
   *  other caller leaves this false and gets the original read-only
   *  rendering unchanged. */
  readonly allowRemove = input(false);
  /** The pick currently being removed, so only its own button disables/
   *  shows a busy state instead of the whole list. */
  readonly removingId = input<number | null>(null);
  readonly remove = output<Pick>();

  readonly regularPicks = computed(() => this.picks().filter((p) => !p.isAlternate));
  readonly alternatePicks = computed(() => this.picks().filter((p) => p.isAlternate));
}
